// src/App.js
import React from "react";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./Login";
import MobileLogin from "./pages/MobileLogin";
import MobileGridApp from "./pages/MobileGridApp";
import GridPage from "./pages/GridPage";
import DrafterGridPage from "./pages/DrafterGridPage";
import HolaAdmin from "./Hola-Admin";
import ProtectedRoute from "./ProtectedRoute";
import Invoicing from "./pages/Invoicing";
import Reportes from "./pages/Reportes";
import HistoryView from "./pages/History-ok";
import ReportesMobile from "./pages/ReportesMobile";
import ReportesWatch from "./pages/ReportesWatch";
import ReportesWeb from "./pages/ReportesWeb";
import email from "./pages/email";



const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
  (typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(max-width: 820px)").matches);

const forceDesktop = () => {
  try {
    const qs = new URLSearchParams(window.location.search);
    return (
      qs.get("desktop") === "1" ||
      localStorage.getItem("sfd_force_desktop") === "1" ||
      sessionStorage.getItem("sfd_force_desktop") === "1"
    );
  } catch {
    return false;
  }
};

const getDesktopLandingPath = () => {
  // Decide destino desktop según la sesión actual (workfun/rol del usuario logueado)
  // IMPORTANTE: preferimos sessionStorage (sesión actual) antes que localStorage (puede estar stale).
  const pick = (raw) => {
    if (raw == null) return null;
    const trimmed = String(raw).trim();
    if (!trimmed) return null;

    // Si parece JSON, intentamos parsear; si falla, seguimos con fallback de string plano.
    const looksJson =
      trimmed.startsWith("{") ||
      trimmed.startsWith("[") ||
      (trimmed.startsWith('"') && trimmed.endsWith('"'));

    if (looksJson) {
      try {
        const j = JSON.parse(trimmed);
        if (typeof j === "string") {
          const s = j.trim();
          return s ? { text: s, obj: null } : null;
        }
        if (j && typeof j === "object") return { text: JSON.stringify(j), obj: j };
      } catch {
        // ignore
      }
    }

    // Fallback: string plano (también quita comillas)
    const plain = trimmed.replace(/^"+|"+$/g, "").trim();
    return plain ? { text: plain, obj: null } : null;
  };

  const candidates = [
    sessionStorage.getItem("loggedWorker"),
    sessionStorage.getItem("sfd_user"),
    localStorage.getItem("loggedWorker"),
    localStorage.getItem("sfd_user"),
  ];

  for (const raw of candidates) {
    const parsed = pick(raw);
    if (!parsed) continue;

    const obj = parsed.obj;
    const text = (parsed.text || "").toLowerCase();

    const workfun = String(
      obj?.workfun ??
        obj?.workFun ??
        obj?.work_function ??
        obj?.role ??
        obj?.type ??
        obj?.profile ??
        ""
    ).toLowerCase();

    const user = String(obj?.user ?? obj?.username ?? obj?.name ?? obj?.project ?? "").toLowerCase();

    // Regla: si el rol/workfun sugiere drafter => /drafter
    if (
      workfun.includes("drafter") ||
      workfun.includes("draft") ||
      user.includes("drafter") ||
      text.includes("drafter") ||
      text.includes("draft")
    ) {
      return "/drafter";
    }

    // Si hay sesión válida pero no es drafter, es GridPage
    return "/gridpage";
  }

  // Sin sesión detectada: default a GridPage
  return "/gridpage";
};

function DesktopOnly({ children }) {
  // En teléfono, normalmente usamos la app móvil.
  // PERO si el usuario activó modo PC (desktop=1 o sfd_force_desktop=1), permitimos ver las páginas PC.
  return isMobile() && !forceDesktop() ? <Navigate to="/mobilegridapp" replace /> : children;
}

function AfterLogin() {
  // Si estás en móvil sin modo PC, vuelve a la app móvil.
  if (isMobile() && !forceDesktop()) return <Navigate to="/mobilegridapp" replace />;
  // Si estás en PC, o en móvil con modo PC, decide GridPage vs Drafter.
  return <Navigate to={getDesktopLandingPath()} replace />;
}



export default function App() {
  // BYPASS PUBLICO: esta pantalla se muestra sin login y sin ProtectedRoute.
  const hash = typeof window !== "undefined" ? window.location.hash : "";
  if (hash === "#/reportes-watch" || hash.startsWith("#/reportes-watch?")) {
    return <ReportesWatch />;
  }
  if (hash === "#/reportes-web" || hash.startsWith("#/reportes-web?")) {
    return <ReportesWeb />;
  }

  return (
    <HashRouter>
      

      <Routes>
        {/* Raíz: envía al login según dispositivo */}
        <Route
          path="/"
          element={<Navigate to={isMobile() && !forceDesktop() ? "/login-mobile" : "/login"} replace />}
        />

        {/* Públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/login-mobile" element={<MobileLogin />} />
             <Route path="/reportes" element={<Reportes />} />
             <Route path="/history-ok" element={<HistoryView />} />
             <Route path="/reportes-movil" element={<ReportesMobile />} />
             <Route path="/reportes-watch" element={<ReportesWatch />} />
             <Route path="/reportes-web" element={<ReportesWeb />} />
             <Route path="/email" element={<email />} />

        {/* Protegidas */}
        <Route element={<ProtectedRoute />}>
          {/* PC */}
          <Route path="/hola-admin" element={<HolaAdmin />} />
          <Route path="/drafter" element={<DesktopOnly><DrafterGridPage /></DesktopOnly>} />
          <Route path="/gridpage" element={<DesktopOnly><GridPage /></DesktopOnly>} />
          <Route path="/GridPage" element={<Navigate to="/gridpage" replace />} />
          <Route path="/after-login" element={<DesktopOnly><AfterLogin /></DesktopOnly>} />

          {/* Móvil */}
          <Route path="/mobilegridapp" element={<MobileGridApp />} />

  <Route path="/invoicing" element={<Invoicing />} />




          {/* Compatibilidad hacia la nueva ruta móvil */}
          <Route path="/hola-mobile" element={<Navigate to="/mobilegridapp" replace />} />
          <Route path="/mobile" element={<Navigate to="/mobilegridapp" replace />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
}
